import {
  EMPLOYEE_CREATE_REQUEST_FAIL,
  EMPLOYEE_CREATE_REQUEST_SUCCESS,
  EMPLOYEE_FIND_REQUEST_FAIL,
  EMPLOYEE_FIND_REQUEST_SUCCESS,
  EMPLOYEE_UPDATE_REQUEST_FAIL,
  EMPLOYEE_UPDATE_REQUEST_SUCCESS,
  SELECT_EMPLOYEE
} from '../action.types';
import initialValue from '../initial.state';

export default function(state = initialValue.employee, action) {
  switch (action.type) {
    case SELECT_EMPLOYEE:
      return { ...action.employee };
    case EMPLOYEE_CREATE_REQUEST_SUCCESS:
      return state;
    case EMPLOYEE_CREATE_REQUEST_FAIL:
      return state;
    case EMPLOYEE_UPDATE_REQUEST_SUCCESS:
      return state;
    case EMPLOYEE_UPDATE_REQUEST_FAIL:
      return state;
    case EMPLOYEE_FIND_REQUEST_SUCCESS:
      return { ...action.payload };
    case EMPLOYEE_FIND_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/employee/employee.reducer.js